import { IOperationTfaCommunication, IOperationTfaDetail } from '../../processes/models/processes.models';
import { NOT_AVAILABLE_DISPLAY } from '../../core/utils/utils';

/** Fuente mínima para resolver teléfono/canal TFA (detalle proceso o data de mensajería). */
export type TfaPhoneChannelSource = Pick<IOperationTfaDetail, 'phone' | 'channel' | 'communications'>;

/** Teléfono mostrable de una sesión TFA (raíz o última comunicación con teléfono). */
export function resolveTfaPhone(tfa: TfaPhoneChannelSource): string {
	if (tfa.phone?.trim()) {
		return tfa.phone.trim();
	}
	const communications = tfa.communications ?? [];
	for (let i = communications.length - 1; i >= 0; i--) {
		const phone = communications[i].phone?.trim();
		if (phone) {
			return phone;
		}
	}
	return NOT_AVAILABLE_DISPLAY;
}

/** Canal normalizado (`sms` | `whatsapp` | ''). */
export function resolveTfaChannel(tfa: TfaPhoneChannelSource): string {
	if (tfa.channel?.trim()) {
		return tfa.channel.trim().toLowerCase();
	}
	const communications = tfa.communications ?? [];
	for (let i = communications.length - 1; i >= 0; i--) {
		const channel = communications[i].channel?.trim().toLowerCase();
		if (channel) {
			return channel;
		}
	}
	return '';
}

/** Clave i18n para etiqueta de canal; cadena vacía si no hay traducción conocida. */
export function resolveTfaChannelLabelKey(channel: string): string {
	if (channel === 'sms') {
		return 'WORKFLOWS.FORM.GENERAL.TWO_FACTOR_SMS';
	}
	if (channel === 'whatsapp') {
		return 'WORKFLOWS.FORM.GENERAL.TWO_FACTOR_WHATSAPP';
	}
	return '';
}

/** Etiqueta de tipo de comunicación TFA (`2fa`, `link`, …). */
export function resolveTfaCommunicationTypeLabel(type: string | undefined): string {
	if (!type?.trim()) {
		return NOT_AVAILABLE_DISPLAY;
	}
	return type.trim();
}

/** Canal de una comunicación concreta. */
export function resolveTfaCommunicationChannel(communication: IOperationTfaCommunication): string {
	return communication.channel?.trim().toLowerCase() || NOT_AVAILABLE_DISPLAY;
}
